import {ExperienceItemModel} from './experience-item.model';

export class ExpertExperienceModel {
  experienceItems: ExperienceItemModel[] = [];
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/experience/expert-experience.model.ts